var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"k-primary",on:{"click":_vm.onClick}},[_vm._v("Add Critter")]),_c('div',{attrs:{"id":"overlay"}})])}
var staticRenderFns = []

export { render, staticRenderFns }